import type { Nullable } from "../@types/generic";

type Variant6032 = "r" | "notset";
export const getVariant6032 = (window: Window): Variant6032 => {
    const landedOutsideReactForecast =
        window.sessionStorage.getItem("wr6032-r") === "";

    if (landedOutsideReactForecast) {
        return "notset";
    }

    return "r";
};

type Variant6462 = "t" | "c" | "f";
export function getVariant6462(window: Window): Variant6462 {
    const existingVariant = window.localStorage.getItem(
        "wr6462-r"
    ) as Nullable<Variant6462>;

    if (existingVariant !== null) {
        return existingVariant;
    }

    const rand = Math.random() * 100;
    let variant: Variant6462 = rand < 40 ? "t" : rand < 80 ? "c" : "f";
    window.localStorage.setItem("wr6462-r", variant);

    return variant;
}
